import { FC, useMemo, useRef } from 'react'
import { HamburgerIcon, CloseIcon, ExternalLinkIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Collapse,
  Flex,
  HStack,
  IconButton,
  Link,
  Menu,
  MenuDivider,
  MenuItem,
  MenuButton,
  MenuList,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react'
import {
  RiArrowLeftSLine,
  RiLayoutGridLine,
  RiSettings4Line,
  RiSimCardLine,
} from 'react-icons/ri'
import { WalletMultiButton } from '../../components/wallet-ui'
import {
  selectedWhiteButtonStyle,
  whiteButtonStyle,
} from '../common/commonStyles'
import { BsEmojiSmile, BsFlag } from 'react-icons/bs'
import { useWallet } from '@solana/wallet-adapter-react'
import { useNativeOrOAuthWallet, useUser } from '../common/auth/authHooks'
import { trpc } from '../../utils/trpc'
import { MerchantStore } from '@prisma/client'
import { getBaseURI } from '../../utils/utils'

interface Props {
  page?: string
}

export const Header: FC<Props> = ({ page }) => {
  const isMobileView = useBreakpointValue({
    base: true,
    lg: false,
  })
  const { isOpen, onToggle, onClose } = useDisclosure()
  const rootRef = useRef<HTMLDivElement>(null)
  useOutsideClick({
    ref: rootRef,
    handler: () => onClose(),
  })
  const wallet = useNativeOrOAuthWallet()

  const menu = useMemo(
    () => (
      <>
        <Link href='/dashboard'>
          <Button
            leftIcon={<RiLayoutGridLine fontSize={16} />}
            style={
              page === 'dashboard' ? selectedWhiteButtonStyle : whiteButtonStyle
            }
          >
            Dashboard
          </Button>
        </Link>
        <Link href='/dashboard/transactions'>
          <Button
            leftIcon={<RiSimCardLine fontSize={16} />}
            style={
              page === 'transactions'
                ? selectedWhiteButtonStyle
                : whiteButtonStyle
            }
          >
            Transactions
          </Button>
        </Link>
        <Link href='/dashboard/settings'>
          <Button
            leftIcon={<RiSettings4Line fontSize={16} />}
            style={
              page === 'setting' ? selectedWhiteButtonStyle : whiteButtonStyle
            }
          >
            Settings
          </Button>
        </Link>

        <OpenPaymentPageMenu></OpenPaymentPageMenu>
      </>
    ),
    [page]
  )

  return (
    <Box pos={'absolute'} height='100%' width='100%' pointerEvents={'none'}>
      <Box
        pointerEvents={'auto'}
        pos={'sticky'}
        top={0}
        w='100%'
        zIndex='200'
        py={'1rem'}
        background='#F3F3F5'
        ref={rootRef}
      >
        <Flex
          justifyContent={'space-between'}
          maxW={'78.5rem'}
          mx='auto'
          paddingX={'1rem'}
          position='relative'
        >
          {page === 'landing' ? (
            <Flex
              gap='1rem'
              width={'100%'}
              justifyContent='flex-end'
              flexDirection={['column', 'row']}
            >
              <Button
                leftIcon={<BsEmojiSmile size={'1rem'} color='#000' />}
                bg='#fff'
                color='#000'
                _hover={{ opacity: 0.9 }}
                border='1px solid #EEEEEE'
                height='32px'
                fontSize={'0.7rem'}
                onClick={() =>
                  window.open(`https://forms.gle/MXH5wN5AbVJ2LGfCA`, '_blank')
                }
              >
                Give Feedback
              </Button>
              <Button
                leftIcon={<BsFlag size={'1rem'} color='#000' />}
                bg='#fff'
                color='#000'
                _hover={{ opacity: 0.9 }}
                border='1px solid #EEEEEE'
                height='32px'
                fontSize={'0.7rem'}
                onClick={() =>
                  window.open(`https://forms.gle/KNiyoei3cydDPuhu8`, '_blank')
                }
              >
                Report issue
              </Button>
              <WalletMultiButton
                style={{
                  background: 'offblack',
                  fontFamily: 'Poppins',
                  fontSize: '.8rem',
                  fontWeight: 600,
                  padding: '0 1rem',
                  borderRadius: '5px',
                  height: '1.7rem',
                  lineHeight: '100%',
                  whiteSpace: 'nowrap',
                  width: 'fit-content',
                }}
              />
            </Flex>
          ) : (
            <>
              {page === 'register' ? (
                <Box>
                  <Link href='/'>
                    <Button
                      leftIcon={<RiArrowLeftSLine fontSize={16} />}
                      style={whiteButtonStyle}
                    >
                      {isMobileView ? '' : 'Back to Overview'}
                    </Button>
                  </Link>
                </Box>
              ) : (
                <HStack spacing={'.5rem'}>
                  {isMobileView ? (
                    <IconButton
                      aria-label='menu-icon'
                      icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                      style={whiteButtonStyle}
                      onClick={onToggle}
                    />
                  ) : (
                    menu
                  )}
                </HStack>
              )}
              {/*<Button
                background={
                  'linear-gradient(90deg, #5FA900 0%, #00713D 100%), #FFFFFF'
                }
                borderRadius='5px'
                color='white'
                fontSize={'16px'}
                fontWeight={600}
                height={'32px'}
                width='190px'
                _hover={{
                  background:
                    'linear-gradient(10deg, #5FA900 0%, #00713D 100%), #FFFFFF',
                }}
                _active={{
                  background:
                    'linear-gradient(90deg, #5FA900 0%, #00713D 100%), #FFFFFF',
                }}
                position='absolute'
                top={0}
                left='calc(50% - 95px)'
              >
                PUFF PAY
              </Button>*/}
              {!isMobileView && (
                <>
                  <Flex
                    gap='1rem'
                    alignItems='center'
                    justifyContent={'flex-end'}
                    flexDirection={['column', 'row']}
                  >
                    <Button
                      leftIcon={<BsEmojiSmile size={'1rem'} color='#000' />}
                      bg='#fff'
                      color='#000'
                      _hover={{ opacity: 0.9 }}
                      border='1px solid #EEEEEE'
                      height='32px'
                      fontSize={'0.7rem'}
                      onClick={() =>
                        window.open(
                          `https://forms.gle/MXH5wN5AbVJ2LGfCA`,
                          '_blank'
                        )
                      }
                    >
                      Give Feedback
                    </Button>
                    <Button
                      leftIcon={<BsFlag size={'1rem'} color='#000' />}
                      bg='#fff'
                      color='#000'
                      _hover={{ opacity: 0.9 }}
                      border='1px solid #EEEEEE'
                      height='32px'
                      fontSize={'0.7rem'}
                      onClick={() =>
                        window.open(
                          `https://forms.gle/KNiyoei3cydDPuhu8`,
                          '_blank'
                        )
                      }
                    >
                      Report issue
                    </Button>

                    <WalletMultiButton
                      style={{
                        background: 'offblack',
                        fontFamily: 'Poppins',
                        fontSize: '.8rem',
                        fontWeight: 600,
                        padding: '0 1rem',
                        borderRadius: '5px',
                        height: '32px',
                        lineHeight: '100%',
                        whiteSpace: 'nowrap',
                      }}
                    />
                  </Flex>
                </>
              )}
            </>
          )}
        </Flex>

        <Collapse in={isOpen} unmountOnExit>
          <Box pb={9}>
            <Flex
              flexDirection={'column'}
              gap='1rem'
              alignItems='flex-start'
              p={'1rem'}
              pb='10rem'
              boxShadow='0px 2px 4px rgb(0 0 0 / 0.15)'
            >
              {menu}
              <WalletMultiButton
                style={{
                  background: 'offblack',
                  fontFamily: 'Poppins',
                  fontSize: '.8rem',
                  fontWeight: 600,
                  padding: '0 1rem',
                  borderRadius: '5px',
                  height: '1.7rem',
                  lineHeight: '100%',
                  whiteSpace: 'nowrap',
                  width: 'fit-content',
                }}
              />
            </Flex>
          </Box>
        </Collapse>
      </Box>
    </Box>
  )
}

export const OpenPaymentPageMenu: React.FC = () => {
  const { isAuthed, solanaAuth } = useUser()
  const merchantRes = trpc.useQuery(
    [
      'merchant.get',
      {
        walletAddress: solanaAuth?.wallet.toBase58() || '',
      },
    ],
    {
      enabled: isAuthed && !!solanaAuth?.wallet,
      refetchInterval: 20000,
      staleTime: 1000 * 60 * 60,
      retry: false,
    }
  )

  console.log('merchantRes header', merchantRes)

  return (
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<ExternalLinkIcon fontSize={14} />}
        variant='link'
        onClick={() => true}
        style={whiteButtonStyle}
      >
        Open Payment Page
      </MenuButton>
      <MenuList border='2px solid offblack' padding='1rem'>
        {(merchantRes.data?.stores ?? []).map(
          (store: MerchantStore, index: number) => {
            return (
              <Box key={store.id}>
                <Link href={`${getBaseURI()}/pay/${store.id}`} target='_blank'>
                  <MenuItem key={store.id}>
                    <Box>
                      <Text fontSize='16px' color='#000' fontWeight={600}>
                        {store.storeName}
                      </Text>
                      <Text
                        fontSize='12px'
                        color='#676767'
                        fontWeight={500}
                      >{`${store.address ? store.address + ', ' : ''}${
                        store.zipCode
                      }, ${store.city}`}</Text>
                    </Box>
                  </MenuItem>
                </Link>
                {index !== (merchantRes?.data?.stores?.length ?? 0) - 1 && (
                  <MenuDivider borderColor={'#F2F2F4'} />
                )}
              </Box>
            )
          }
        )}
      </MenuList>
    </Menu>
  )
}
